import { Box, styled, Theme, Typography } from '@mui/material';

export const ChatsListHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '0 24px',
    marginBottom: '24px',

    [theme.breakpoints.down('tablet')]: {
      padding: '0 16px',
    },
  };
});

export const ChatsListHeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#2B163F',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',

    span: {
      color: '#857F8B',
    },
  };
});

export const ChatsListHeaderDesc = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#2B163F',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '136%',
    whiteSpace: 'pre-line',
  };
});
